export const getComposedData = (response = {}) => {
  const items = response?.items || []

  return items.map(row => ({
    ...row,
    // normalize customerId and keep used as a boolean for UI rendering
    customerId: row.customerId || '',
    used: !!row.used,
  }))
}
